import api_comm from "./lib";

async function profileSetup(storemember_guid, storemember_details) {
	let storeMember = {
		id_passport_number: storemember_details["ID/Passport Number"],
		first_name: storemember_details["First Name"],
		second_name: storemember_details["Last Name"],
		role_guid: storemember_details["Role"].value,
		store_guid: storemember_details["Store"].value,
		email_address: storemember_details["Email Address"],
		gender: storemember_details["Gender"].value,
		password: storemember_details["Password"],
	};

	return api_comm(
		"put",
		"/members/api/v2/account/" + storemember_guid,
		storeMember
	);
}

export default profileSetup;
